<template>
    <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
       <AdminNavbar/>

        <div class="page-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('Welcome!')}}</h2>
                        <span class="ipn-subtitle">{{ $t('Welcome To Your Account') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <section class="bg-light">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="filter_search_opt">
                            <router-link to="" @click="show = !show" class="btn btn-dark full-width mb-4">{{ $t('Dashboard Navigation') }}<i class="fa-solid fa-bars ms-2 px-2"></i></router-link>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <AdminSidebar :open="show" @update:open="show = $event" :userData="userData" :category-name="categoryName" :state-name="stateName"/>
                    </div>
                    
                    <div class="col-lg-9 col-md-12">                
                        <div class="dashboard-wraper">
                            <form  @submit.prevent="submitSupplierForm">
                            <!-- Full Name and Email -->
                            <div class="row">
                              <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Full Name') }}</label><span class="text-danger">*</span>
                                  <input type="text" class="form-control" v-model="supplierForm.name" :placeholder="$t('Full Name')" required/>
                                  <small class="text-danger" v-if="supplierErrors.name">{{ supplierErrors.name[0] }}</small>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Address') }}</label>
                                  <input type="text" class="form-control" v-model="supplierForm.address" :placeholder="$t('Address')"/>
                                  <small class="text-danger" v-if="supplierErrors.address">{{ supplierErrors.address[0] }}</small>
                                  </div>
                              </div>
                              <!-- <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Email') }}</label>
                                  <input type="text" class="form-control" v-model="supplierForm.email" :placeholder="$t('Your Email')" />
                                  <small class="text-danger" v-if="supplierErrors.email">{{ supplierErrors.email[0] }}</small>
                                  </div>
                              </div> -->
                            </div>

                            <!-- Phone and Password -->
                            <div class="row">
                                <!-- <div class="col-lg-6 col-md-6">
                                    <div class="form-group mb-3">
                                    <label class="mb-1">{{ $t('Phone') }}</label>
                                    <input type="tel" class="form-control" v-model="supplierForm.phone" :placeholder="$t('Phone')" />
                                    <small class="text-danger" v-if="supplierErrors.phone">{{ supplierErrors.phone[0] }}</small>
                                    </div>
                                </div> -->
                                <!-- <div class="col-lg-6 col-md-6 mb-3">
                                    <div class="form-group">
                                    <label class="mb-1">{{ $t('Password') }}</label>
                                    <input type="password" class="form-control" v-model="supplierForm.password" placeholder="*******" />
                                    <small class="text-danger" v-if="supplierErrors.password">{{ supplierErrors.password[0] }}</small>
                                    </div>
                                </div> -->
                            </div>

                            <!-- Career and specialization -->
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group mb-3">
                                    <label class="mb-1">{{ $t('Category') }}</label><span class="text-danger">*</span>
                                    <select class="form-control" v-model="supplierForm.category_id">
                                        <option disabled value="">{{ $t('Select Category') }}</option>
                                        <option v-for="category in categories" :key="category.value" :value="category.value">
                                        {{ category.label }}
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="supplierErrors.category">{{ supplierErrors.category[0] }}</small>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                      <div class="form-group mb-3">
                                            <label class="mb-1">{{ $t('specialization') }}</label>
                                            <select class="form-control" v-model="supplierForm.subcategory_id">
                                                <option disabled value="">{{ $t('Select specialization') }}</option>
                                                <option v-for="subcategory in subCategories" :key="subcategory.value" :value="subcategory.value">
                                                {{ subcategory.label }}
                                                </option>
                                            </select>
                                            <small class="text-danger" v-if="supplierErrors.subcategory_id">{{ supplierErrors.subcategory_id[0] }}</small>
                                      </div>
                                </div>
                            </div>
                            <!-- Area and State -->
                            <div class="row">
                              <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('City') }}</label><span class="text-danger">*</span>
                                  <select class="form-control" v-model="supplierForm.state_id">
                                      <option disabled value="">{{ $t('Select City') }}</option>
                                      <option v-for="state in states" :key="state.value" :value="state.value">
                                      {{ state.label }}
                                      </option>
                                  </select>
                                  <small class="text-danger" v-if="supplierErrors.state">{{ supplierErrors.state[0] }}</small>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-md-6">
                                    <div class="form-group mb-3">
                                          <label class="mb-1">{{ $t('Area') }}</label>
                                          <select class="form-control" v-model="supplierForm.city_id">
                                              <option disabled value="">{{ $t('Select Area') }}</option>
                                              <option v-for="city in cities" :key="city.value" :value="city.value">
                                              {{ city.label }}
                                              </option>
                                          </select>
                                          <small class="text-danger" v-if="supplierErrors.city_id">{{ supplierErrors.city_id[0] }}</small>
                                    </div>
                              </div>
                            </div>

                            <!-- Socials -->
                            <div class="row">
                              <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Whatsapp') }}</label><span class="text-danger">*</span>
                                  <input type="tel" class="form-control" v-model="supplierForm.whatsapp" :placeholder="$t('Whatsapp')" />
                                  <small class="text-danger" v-if="supplierErrors.whatsapp">{{ supplierErrors.whatsapp[0] }}</small>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-md-6 mb-3">
                                  <div class="form-group">
                                  <label class="mb-1">{{ $t('Instagram') }}</label>
                                  <input type="text" class="form-control" v-model="supplierForm.instagram" :placeholder="$t('Instagram')" />
                                  <small class="text-danger" v-if="supplierErrors.instagram">{{ supplierErrors.instagram[0] }}</small>
                                  </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-lg-6 col-md-6 mb-3">
                                  <div class="form-group">
                                  <label class="mb-1">{{ $t('Telegram') }}</label>
                                  <input type="text" class="form-control" v-model="supplierForm.telegram" :placeholder="$t('Telegram')" />
                                  <small class="text-danger" v-if="supplierErrors.telegram">{{ supplierErrors.telegram[0] }}</small>
                                  </div>
                              </div>
                              <div class="col-lg-6 col-md-6 mb-3">
                                  <div class="form-group">
                                  <label class="mb-1">{{ $t('Facebook') }}</label>
                                  <input type="text" class="form-control" v-model="supplierForm.facebook" :placeholder="$t('Facebook')" />
                                  <small class="text-danger" v-if="supplierErrors.facebook">{{ supplierErrors.facebook[0] }}</small>
                                  </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <label>{{ $t('Location') }}</label>
                              <MapPicker :location="location" @update:location="onLocationChange" :latitude="supplierForm.latitude"
                              :longitude="supplierForm.longitude"/>                            
                            </div>
                            <br>
                            <!-- Working Hours -->
                            <div v-for="day in weekDay" :key="day.value" class="mb-3">
                            <label class="fw-bold">{{ day.label }}</label>

                            <div
                                v-for="(slot, index) in supplierForm.working_hours[day.value] || []"
                                :key="index"
                                class="row align-items-center mb-2"
                            >
                                <div class="col-md-4">
                                <input
                                    type="time"
                                    class="form-control"
                                    v-model="slot.from_time"
                                    :placeholder="$t('From Time')"
                                />
                                <small class="text-danger" v-if="slot.errorFrom">{{ slot.errorFrom }}</small>
                                </div>
                                <div class="col-md-4">
                                <input
                                    type="time"
                                    class="form-control"
                                    v-model="slot.to_time"
                                    :placeholder="$t('To Time')"
                                />
                                <small class="text-danger" v-if="slot.errorTo">{{ slot.errorTo }}</small>
                                </div>

                                <div class="col-md-4 d-flex gap-2">
                                <button
                                    class="btn btn-sm btn-danger"
                                    @click.prevent="removeTimeSlot(day.value, index)"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>

                                <button
                                    v-if="index === supplierForm.working_hours[day.value].length - 1"
                                    class="btn btn-sm btn-success"
                                    @click.prevent="addTimeSlot(day.value)"
                                >
                                    <i class="fa fa-plus"></i>
                                </button>
                                </div>
                            </div>
                            </div>
                            <div class="row">
                            <!-- Public Profile Toggle -->
                              <div class="col-lg-6 col-md-6 mb-3">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('User Status') }}</label><span class="text-danger">*</span>
                                  <select v-model="supplierForm.user_show" class="form-control">
                                      <option disabled value="">{{ $t('Select Status') }}</option>
                                      <option :value="1">{{ $t('Active') }}</option>
                                      <option :value="0">{{ $t('Inactive') }}</option>
                                  </select>
                                  <small class="text-danger" v-if="supplierErrors.user_show">{{ supplierErrors.user_show[0] }}</small>
                                  </div>
                              </div>
                            <!-- Profile Image -->
                              <div class="col-lg-6 col-md-6 mb-3">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Profile Image') }}</label>
                                  <input
                                      type="file"
                                      class="form-control"
                                      accept="image/*"
                                      @change="handleProfileImageUpload"
                                  />
                                  <small class="text-danger" v-if="supplierErrors.profile_image">{{ supplierErrors.profile_image[0] }}</small>
                                  </div>
                                  <div class="mb-3">
                                  <img 
                                      v-if="supplierForm.profile_image"
                                      :src="supplierForm.profile_image" 
                                      alt="Profile" 
                                      class="img-thumbnail rounded" 
                                      style="height: 150px; width: 150px; object-fit: cover;"
                                  />
                                  </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6 col-md-6">
                                <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Branch Name') }}<span class="text-danger">*</span></label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="supplierForm.branch_name"
                                    :placeholder="$t('Branch Name')"
                                    required
                                    name="branch_name"
                                  />
                                  <small class="text-danger" v-if="supplierErrors.branch_name">{{ supplierErrors.branch_name[0] }}</small>
                                </div>
                              </div>
                              
                              <!-- Gallery -->
                              <div class="col-lg-6 col-md-6">
                                    <div class="form-group mb-3">
                                      <label class="mb-1">{{ $t('Business Gallery') }}</label>
                                      <input
                                          type="file"
                                          class="form-control"
                                          multiple
                                          accept="image/*"
                                          @change="handleGalleryUpload"
                                      />
                                      <small class="text-danger" v-if="supplierErrors.galleries">
                                          {{ supplierErrors.galleries[0] }}
                                      </small>
                                    </div>

                                    <div class="row">
                                      <div
                                          v-for="(img, index) in supplierForm.galleries"
                                          :key="index"
                                          class="col-md-3 mb-3 position-relative"
                                      >
                                        <img
                                        :src="img.url"
                                        alt="Gallery Image"
                                        class="img-fluid rounded shadow-sm"
                                        style="height: 120px; object-fit: cover;"
                                        />
                                        <button
                                        type="button"
                                        class="btn btn-sm btn-danger position-absolute"
                                        style="top: 5px; right: 5px;"
                                        @click="removeGalleryImage(index)"
                                        >
                                        ×
                                        </button>
                                      </div>
                                    </div>

                              </div>
                              <!-- Description -->
                              <div class="col-lg-6 col-md-6">
                                  <div class="form-group mb-3">
                                  <label class="mb-1">{{ $t('Service Description') }}</label><span class="text-danger">*</span>
                                  <textarea class="form-control" rows="4" v-model="supplierForm.about" :placeholder="$t('Service Description')"></textarea>
                                  <small class="text-danger" v-if="supplierErrors.about">{{ supplierErrors.about[0] }}</small>
                                  </div>
                              </div>
                            </div>                            
                            <div class="form-group">
                            <button type="submit" class="btn btn-primary full-width fw-medium">
                                {{ $t('Update') }}
                                <i class="fa-solid px-2" :class="$i18n.locale === 'ar' ? 'fa-arrow-left-long' : 'fa-arrow-right-long'"></i>
                            </button>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>

        <FooterDark/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
import { ref, watch ,computed} from 'vue';
import axios from 'axios';
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import AdminSidebar from '@/components/admin-sidebar.vue';
import AdminNavbar from '@/components/navbar/admin-navbar.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';


// import your new map picker
import MapPicker from '@/components/MapPicker.vue';




const toast = useToast();
const { t, locale } = useI18n();
const token = localStorage.getItem('auth_token');

const userData = ref(null);
const cities = ref([]);
const states = ref([]);
const categories = ref([]);
const subCategories = ref([]);
const weekDay = ref([]);
const loading = ref(false);
const supplierErrors = ref({});

const oldGalleryUrls = ref([]);

const supplierForm = ref({
  name: '',
  // email: '',
  // phone: '',
  // password: '',
  state_id: '',
  category_id: '',
  about: '',
  user_show: '',
  whatsapp: '',
  telegram: '',
  facebook: '',
  instagram: '',
  city_id: '',
  subcategory_id: '',
  galleries: [], 
  newGalleryFiles: [],
  working_hours: {},
  profile_image: null,
  address:'',
  latitude:'',
  longitude:'',
  branch_name:''
});
const location = ref({ lat: 34.8021, lng: 38.9968, address: '' });

function onLocationChange(newLoc) {
  location.value = newLoc;
  supplierForm.value.latitude = newLoc.lat;
  supplierForm.value.longitude = newLoc.lng;
  console.log('Location updated:', newLoc);
}
const fetchSubCategories = async (category_id) => {
  try {
    const response = await axios.get(`/get-subcategories`, {
      params: { category_id },
      headers:{
        locale:locale.value
      }
    });
    const fetchedSubCategories = response.data.subcategory || [];
    subCategories.value = fetchedSubCategories.map(subCategory => ({
      label: subCategory.name,
      value: subCategory.id
    }));
  } catch (error) {
    console.error("Error fetching subcategories:", error);
  }
};

watch(() => supplierForm.value.category_id, (newVal) => {
  if (newVal) {
    fetchSubCategories(newVal);
  } else {
    categories.value = [];
    supplierForm.value.category_id = '';
  }
});
const fetchCities = async (stateId) => {
  try {
    const response = await axios.get(`/get-cities/${stateId}`,{
      headers:{
        locale:locale.value
      }
    });
    const fetchedCities = response.data.cities || [];
    cities.value = fetchedCities.map(city => ({
      label: city.name,
      value: city.id
    }));
  } catch (error) {
    console.error("Error fetching cities:", error);
  }
};

watch(() => supplierForm.value.state_id, (newVal) => {
  if (newVal) {
    fetchCities(newVal);
  } else {
    cities.value = [];
    supplierForm.value.city_id = '';
  }
});

const fetchStates = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-states`,{
      headers:{
        locale:locale.value
      }
    });
    const fetchedStates = response.data.states || [];
    states.value = fetchedStates.map(state => ({
      label: state.name,
      value: state.id
    }));
  } catch (error) {
    console.error("Error fetching states:", error);
  } finally {
    loading.value = false;
  }
};

const fetchCategories = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-categories`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedCategories = response.data.categories || [];
    categories.value = fetchedCategories.map(category => ({
      label: category.name,
      value: category.id
    }));
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    loading.value = false;
  }
};
const categoryName = computed(() => {
    if (!userData.value?.service_provider_details?.category) return '';
    return userData.value.service_provider_details.category.name
});

const stateName = computed(() => {
    if (!userData.value?.service_provider_details?.state) return '';        
    return  userData.value.service_provider_details.state.name
}); 
watch(locale, fetchStates, { immediate: true });
watch(locale, fetchCategories, { immediate: true });

const fetchWeekDay = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/get-week-days', {
      headers: {
        'Locale': locale.value
      }
    });
    const days = response.data.WeekDay || [];
    weekDay.value = days.map(day => ({
      label: t(day.charAt(0).toUpperCase() + day.slice(1)),
      value: day
    }));
  } catch (error) {
    console.error("Error fetching weekDay:", error);
  } finally {
    loading.value = false;
  }
};


watch(locale, fetchWeekDay, { immediate: true });

axios.get('/users/service-provider/show-details', {
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json'
  }
}).then(response => {
  const data = response.data.service_provider_details;
  userData.value = response.data;

  supplierForm.value.name = data.name || '';
  supplierForm.value.address = data.address || '';
  // supplierForm.value.email = data.email || '';
  // supplierForm.value.phone = data.phone || '';
  supplierForm.value.category_id = data.category?.id || '';
  supplierForm.value.state_id = data.state?.id || '';
  supplierForm.value.city_id = data.city?.id || '';
  supplierForm.value.subcategory_id = data.subcategory?.id || '';
  supplierForm.value.about = data.about || '';
  supplierForm.value.whatsapp = data.whatsapp || '';
  supplierForm.value.instagram = data.instagram || '';
  supplierForm.value.telegram = data.telegram || '';
  supplierForm.value.facebook = data.facebook || '';
  supplierForm.value.user_show = data.user_show ?? '';
  supplierForm.value.branch_name = data.branches?.find(branch => branch.type === 'main')?.name ?? '';
  oldGalleryUrls.value = data.gallery?.map(g => ({
    id: g.id,
    url: g.image_url
  })) || [];

  supplierForm.value.latitude =
    data.latitude !== null &&
    data.latitude !== undefined &&
    data.latitude !== ''
      ? Number(data.latitude)
      : '';

  supplierForm.value.longitude =
    data.longitude !== null &&
    data.longitude !== undefined &&
    data.longitude !== ''
      ? Number(data.longitude)
    : '';
  const lat =
    data.latitude !== null &&
    data.latitude !== undefined &&
    data.latitude !== ''
      ? Number(data.latitude)
      : 34.8021;

  const lng =
    data.longitude !== null &&
    data.longitude !== undefined &&
    data.longitude !== ''
      ? Number(data.longitude)
      : 38.9968;

  location.value = {
    lat,
    lng,
    address: data.address || ''
  };
  supplierForm.value.galleries = [...oldGalleryUrls.value];
  supplierForm.value.profile_image = data.profile_image ? data.profile_image : null;

  const workDays = data.work_days || [];
  const workingHours = {};
  workDays.forEach(dayEntry => {
    const day = dayEntry.day;
    if (!workingHours[day]) workingHours[day] = [];
    workingHours[day].push({
      from_time: dayEntry.from_time,
      to_time: dayEntry.to_time,
      errorFrom: '',
      errorTo: ''
    });
  });
  weekDay.value.forEach(day => {
    if (!workingHours[day.value]) {
      workingHours[day.value] = [{ from_time: '', to_time: '', errorFrom: '', errorTo: '' }];
    } else {
      workingHours[day.value].forEach(slot => {
        if (slot.errorFrom === undefined) slot.errorFrom = '';
        if (slot.errorTo === undefined) slot.errorTo = '';
      });
    }
  });

  supplierForm.value.working_hours = workingHours;
}).catch(error => {
  console.error("Axios error:", error);
});

// const phoneRegex = /^\+?[0-9]{10,15}$/;
// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const whatsappRegex = /^\+?[1-9]\d{7,14}$/; 
const handleProfileImageUpload = (e) => {
  supplierForm.value.profile_image = e.target.files[0] || null;
};

const handleGalleryUpload = (e) => {
const files = Array.from(e.target.files);

files.forEach(file => {
    supplierForm.value.newGalleryFiles.push(file);
});

supplierForm.value.galleries = [
    ...oldGalleryUrls.value,
    ...supplierForm.value.newGalleryFiles 
];

e.target.value = null;
};

const removeGalleryImage = async (index) => {
  const img = supplierForm.value.galleries[index];

  if (typeof img === 'object' && img.id) {
    // صورة قديمة، حذف من السيرفر
    try {
      await axios.delete(`/image-gallery-delete/${img.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // إزالة من الصور القديمة
      oldGalleryUrls.value = oldGalleryUrls.value.filter(i => i.id !== img.id);
    } catch (err) {
      console.error("Failed to delete image:", err);
      toast.error(t("Failed to delete image."));
      return;
    }
  }

  if (img instanceof File) {
    supplierForm.value.newGalleryFiles = supplierForm.value.newGalleryFiles.filter(f => f !== img);
  }

  // تحديث قائمة المعرض
  supplierForm.value.galleries = [
    ...oldGalleryUrls.value,
    ...supplierForm.value.newGalleryFiles
  ];
};

const addTimeSlot = (day) => {
  if (!supplierForm.value.working_hours[day]) {
    supplierForm.value.working_hours[day] = [];
  }
  supplierForm.value.working_hours[day].push({ from_time: '', to_time: '', errorFrom: '', errorTo: '' });
};

const removeTimeSlot = (day, index) => {
  supplierForm.value.working_hours[day].splice(index, 1);
};

const submitSupplierForm = async () => {
  supplierErrors.value = {};
  let formValid = true;
  let timeError = false;

  const requiredFields = ['name','state_id', 'category_id', 'about', 'user_show', 'whatsapp'];

  // if (supplierForm.value.phone && !phoneRegex.test(supplierForm.value.phone)) {
  //   supplierErrors.value.phone = [t('validation.invalid_format', { field: t('fields.phone') })];
  //   formValid = false;
  // }

  // if (supplierForm.value.email && !emailRegex.test(supplierForm.value.email)) {
  //   supplierErrors.value.email = [t('validation.invalid_format', { field: t('fields.email') })];
  //   formValid = false;
  // }

  requiredFields.forEach((field) => {
    const value = supplierForm.value[field];
    const isEmpty = field === 'user_show'
      ? value === '' || value === null || value === undefined
      : !value;

    if (isEmpty) {
      supplierErrors.value[field] = [t('validation.required', { field: t(`fields.${field}`) })];
      formValid = false;
    }
  });

  // if (!supplierForm.value.galleries.length) {
  //   supplierErrors.value.galleries = [t('validation.required', { field: t('fields.galleries') })];
  //   formValid = false;
  // } 
  const profileImage = supplierForm.value.profile_image;
  const hasExistingImage = typeof profileImage === 'string' && profileImage !== '';
  const hasNewImage = profileImage instanceof File;
  console.log("hasExistingImage",hasExistingImage);
  if (supplierForm.value.whatsapp && !whatsappRegex.test(supplierForm.value.whatsapp)) {
    supplierErrors.value.whatsapp = [t('validation.invalid_whatsapp', { field: t('fields.whatsapp') })];
    formValid = false;
  }
  if (!hasExistingImage && !hasNewImage) {
    supplierErrors.value.profile_image = [t('validation.required', { field: t('fields.profile_image') })];
    formValid = false;
  }


  let hasWorkingHours = false;

  for (const day in supplierForm.value.working_hours) {
    const slots = supplierForm.value.working_hours[day];
    if (slots.length > 0) hasWorkingHours = true;

    slots.forEach(slot => {
      slot.errorFrom = '';
      slot.errorTo = '';
      const translatedDay = t(day.charAt(0).toUpperCase() + day.slice(1));

      // if (!slot.from_time) {
      //   slot.errorFrom = `${t('From Time')} ${t('validation.required', { field: '', day: translatedDay })}`;
      //   timeError = true;
      // }

      // if (!slot.to_time) {
      //   slot.errorTo = `${t('To Time')} ${t('validation.required', { field: '', day: translatedDay })}`;
      //   timeError = true;
      // }

      if (slot.from_time && slot.to_time && slot.from_time >= slot.to_time) {
        slot.errorFrom = `${t('From Time')} must be less than ${t('To Time')} on ${translatedDay}`;
        slot.errorTo = `${t('To Time')} must be greater than ${t('From Time')} on ${translatedDay}`;
        timeError = true;
      }
    });
  }

  if (!hasWorkingHours) {
    alert(t("At least one working day with time slot is required."));
    return;
  }

  if (!formValid || timeError) return;

  const formData = new FormData();

  for (const key in supplierForm.value) {
    const value = supplierForm.value[key];

    if (key === 'galleries') {
    //   oldGalleryUrls.value.forEach((obj, i) => {
    //     formData.append(`galleries[${i}]`, obj.url);
    //   });
      supplierForm.value.newGalleryFiles.forEach((file, i) => {
        formData.append(`galleries[${oldGalleryUrls.value.length + i}]`, file);
      });
    } else if (key === 'working_hours') {
      for (const day in value) {
        value[day].forEach((slot, index) => {
          formData.append(`working_hours[${day}][${index}][from_time]`, slot.from_time || '');
          formData.append(`working_hours[${day}][${index}][to_time]`, slot.to_time || '');
        });
      }
    }  else if (key === 'profile_image') {
      if (value instanceof File) {
        formData.append('profile_image', value);
      }
    } else {
      const val = typeof value === 'boolean' ? (value ? '1' : '0') : value;
      formData.append(key, val);
    }
  }

  try {
    const res = await axios.post('/users/service-provider/update', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    toast.success(t('Your Account Updated Successfully.'));
    window.location.reload();
    console.log(res);
    
  } catch (error) {
    if (error.response && error.response.status === 422) {
      supplierErrors.value = error.response.data || {};
      toast.error(Object.values(supplierErrors.value).flat().join('\n'));
    } else {
      console.error(error);
      toast.error(t('An unexpected error occurred. Please try again.'));
    }
  }
};

watch(weekDay, (days) => {
  days.forEach(day => {
    if (!supplierForm.value.working_hours[day.value]) {
      supplierForm.value.working_hours[day.value] = [{ from_time: '', to_time: '', errorFrom: '', errorTo: '' }];
    } else {
      supplierForm.value.working_hours[day.value].forEach(slot => {
        if (slot.errorFrom === undefined) slot.errorFrom = '';
        if (slot.errorTo === undefined) slot.errorTo = '';
      });
    }
  });
}, { immediate: true });

</script>

<style scoped>
.d-flex.gap-2 {
  align-items: center;
}
</style>